module.exports = __webpack_public_path__ + "media/icons/person-in-courthouse-3d42ec6e.png";